import { IRegistrationFormValues } from '../../modules/api/repositories/registration/registration.types';

export enum TrackerEvents {
  ANNOUNCE_COMPLETE = 'ANNOUNCE_COMPLETE',
  FIRST_TIME_SUBSCRIBE = 'FIRST_TIME_SUBSCRIBE',
  PROFILE_COMPLETE = 'PROFILE_COMPLETE',
  PURCHASE_COMPLETE = 'PURCHASE_COMPLETE',
  REGISTER_COMPLETE = 'REGISTER_COMPLETE',
  UPLOAD_PHOTO_COMPLETE = 'UPLOAD_PHOTO_COMPLETE',
}

export interface ITrackerStrategy {
  trackPageView(page: string): void;
  trackEvent(event: TrackerEvents, params?: IRegistrationFormValues): void;
}

// this class is currently only used in affiny-app for Adjust tracking
class Tracker {
  private instance: ITrackerStrategy;
  public configure = (value: ITrackerStrategy): void => {
    this.instance = value;
  };
  public get strategy(): ITrackerStrategy {
    if (!this.instance) {
      throw new Error(
        'affiny-core/services/tracking/tracker.ts you cannot call .strategy before configure it. Search Tracker.configure() method'
      );
    }

    return this.instance;
  }
}

export const tracker = new Tracker();
